<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                tableHeaderColor="purple"
                title="Lieferanten"
                v-bind:subTitle="subTitle"
                showFilter="true"
                sortBy="supplier"
                v-bind:actions="actions"
                v-bind:data="this.suppliers"
                v-bind:dict="this.suppliersDict"
                hasRatings="true"
        ></p-s-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { PSTable } from "@/components";
  import store from '@/store/index.js';
  import api from "@/api/api";

export default {
  name: "SupplierRating",
  components: {
    PSTable
  },
  data() {
    return {
      suppliers: [],
      suppliersDict: [
        { key: 'supplier', label: 'Name', type: 'string'},
        { key: 'city', label: 'Stadt', type: 'string'},
        { key: 'numberofproducts', label: 'Anzahl Produkte', type: 'number'},
        { key: 'revenue', label: 'Gesamtumsatz für diesen Lieferanten', type: 'price'},
        { key: 'rating', label: 'Bewertung', type: 'rating'}
      ],
      actions: [
        {
          action: this.openSupplierDetails,
          icon: "search"
        }
      ]
    }
  },
  created () {
    store.commit("setLoading", true);

    api.getSuppliers().then((result) => {
      this.suppliers = result.data;

      store.commit("setLoading", false);
    });
  },
  computed: {
    subTitle() {
      return "insgesamt " + this.suppliers.length + " Lieferanten";
    }
  },
  methods: {
    openSupplierDetails(item) {
      const id = item.id;
      let routeData = this.$router.resolve({ name: 'Lieferantendetails', params: { id } });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>
